import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faGoogle,
	faFacebookF,
	faApple,
	faTwitter,
	faInstagram,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faGoogle, faFacebookF, faApple, faTwitter, faInstagram)

export default Vue.component('font-awesome-icon', FontAwesomeIcon)
